import React, { useEffect, useState } from "react";
import AccessControlContext from "./customers2/components/AccessControlContext";
import { requestsV1 } from "./customers/utils";
import { AccessControl } from "./customers2/utils/AccessControl";

const AccessControlProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);

  const accessControl = new AccessControl([...permissions]);

  useEffect(() => {
    requestsV1.get("/profile").end((err, resp) => {
      if (resp.ok && resp.body.permissions) {
        setPermissions(resp.body.permissions);
      }
    });
  }, []);

  return (
    <AccessControlContext.Provider value={{ accessControl }}>
      {children}
    </AccessControlContext.Provider>
  );
};

export default AccessControlProvider;
